function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './style/style.scss';
import { Application } from "zengular";
import CookieConsentBrick from './bricks/cookie-consent.brick';
import AppEvents from "./modules/constants/app-events";
import service from "./modules/services/services";
import AcceptTerms from "./modals/accept-terms.brick";
import PasswordReset from "./modals/password-reset.brick";
import ShowTerms from "./modals/show-terms.brick";
import { RespoHandler } from "zengular-ui";
import "./style/misc/balloon.scss"; import "./style/misc/customize.scss"; import "./style/misc/fontawesome.scss"; import "./style/misc/google-fonts.scss";
import "./template/components/article-list-item.scss"; import "./template/components/article-view-body.scss"; import "./template/components/article-view-head.scss"; import "./template/components/article-view.scss"; import "./template/components/blog-view.scss"; import "./template/components/blog-wide-container.scss"; import "./template/components/blogger-header-section.scss"; import "./template/components/bloggers-section.scss"; import "./template/components/blogpost-list-item.scss"; import "./template/components/content/topic.scss"; import "./template/components/index/features-section.scss"; import "./template/components/index/topics-section.scss"; import "./template/components/news-flow-section.scss"; import "./template/components/page/footer.scss"; import "./template/components/page/header.scss"; import "./template/components/page/skin.scss"; import "./template/components/topic-list.scss"; import "./template/layouts/article.scss"; import "./template/layouts/blog.scss"; import "./template/layouts/blogs.scss"; import "./template/layouts/content-list.scss"; import "./template/layouts/index.scss"; import "./template/page/content/topic.scss";
import "./bricks/banner/bnr-monster.brick.js"; import "./bricks/banner/bnr-mpu.brick.js"; import "./bricks/comment/comment-stream.brick.js"; import "./bricks/content-nav.brick.js"; import "./bricks/cookie-consent.brick.js"; import "./bricks/gallery.brick.js"; import "./bricks/header-nav.brick.js"; import "./bricks/pager.brick.js"; import "./bricks/podcast-player.brick.js"; import "./bricks/search-bar.brick.js"; import "./bricks/skin.brick.js"; import "./bricks/tiles.brick.js"; import "./bricks/topic-favorite.brick.js";
import FinalizeRegistration from "./modals/finalize-registration.brick";
import SessionEvents from "./modules/constants/session-events";
import Alert from "./modals/alert.brick";
import AppEvent from "zengular/src/app-event";
var application = new ( /*#__PURE__*/function (_Application) {
  _inherits(_class, _Application);

  var _super = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "initialize",
    value: function initialize() {
      if (service.User.current) {
        CookieConsentBrick.set();
      }
    }
  }, {
    key: "run",
    value: function run() {
      AppEvent.broadcast('app-init-done');
      if (service.SiteData.events[SessionEvents.FinalizeRegistration]) FinalizeRegistration.modalify(service.SiteData.events[SessionEvents.FinalizeRegistration]);
      if (service.SiteData.events[SessionEvents.TermsAcceptRequired]) AcceptTerms.modalify(true);
      if (service.SiteData.events[SessionEvents.PasswordReset]) PasswordReset.modalify(service.SiteData.events[SessionEvents.PasswordReset]);
      if (service.SiteData.events[SessionEvents.Message]) Alert.alert('RobotMajom mondja', 'fas fa-info-circle', service.SiteData.events[SessionEvents.Message]);
      new RespoHandler({
        small: {
          min: 0,
          max: 680
        },
        medium: {
          min: 680,
          max: 1020
        },
        large: {
          min: 1020,
          max: Infinity
        }
      }, function (mode) {
        console.log(mode);

        if (mode === 'small') {
          document.body.style.zoom = window.innerWidth / 340;
        } else {
          document.body.style.removeProperty('zoom');
        } //				document.body.classList.remove(document.body.dataset.prevRespoState);
        //				document.body.dataset.prevRespoState = mode;
        //				document.body.classList.add(mode);

      });
      var count = 0;
      document.querySelectorAll('.column-item').forEach(function (item) {
        setTimeout(function () {
          item.classList.add('column-item-visible');
        }, count * 30);
        count++;
      });
    }
  }]);

  return _class;
}(Application))();
export default application;